export default Object.freeze({
	developUrl: 'https://dev.rolrom.fr',
	productionUrl: 'https://air.rolrom.fr',
	defaultApplicationPicture: '/assets/img/placeholder.png',
	iconsPath: '/assets/svg/',
	defaultUserAvatar: '/assets/img/defaultUserAvatar.png',
	imgPath: '/assets/img/',
});
